import { Controller } from "stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = [
    "container",
    "couponData",
    "couponId",
    "namePreview",
    "pricePreview",
    "valuePreview",
    "typePreview",
    "singlePreview",
    "cashPreview",
    "validityPreview",
    "stockPreview",
    "expirationDatePreview",
    "descriptionPreview",
    "amountPreview",
    "promocodePreview",
    "websiteUrlPreview",
    "promocode",
    "messageComponent",
    "errorIcon",
    "successIcon",
    "message",
    "submitButton"
  ];

  static values = {
    usersPoints: Number,
  };

  connect(){
    document.querySelectorAll("#link")
    const links = document.querySelectorAll("#link");

    for (let i = 0; i < links.length; i++) {
        links[i].addEventListener("click", function(e) {
          e.stopPropagation();
        });
    }
  }


  change_value(event) {
    const value = event.target.value;
    if(event.target.options[event.target.selectedIndex].text == "discount"){
      this.typePreviewTarget.innerText = " €"
    }
    else if(event.target.options[event.target.selectedIndex].text != "x+y"){
      this.typePreviewTarget.innerText =
          event.target.options[event.target.selectedIndex].text;
    }
    else{
      this.typePreviewTarget.innerText = ""
    }
    this.valuePreviewTarget.innerText = "";

    get(`/company/coupons/change_value?type=${value}&locale=${current_locale}`, {
      responseKind: "turbo-stream",
    });
  }

  change_type(event){
    const value = event.target.value;
    get(`/company/coupons/change_value?type=${value}&locale=${current_locale}`, {
      responseKind: "turbo-stream",
    });
  }

  change_value_preview(event) {
    if(this.valuePreviewTarget){
      this.valuePreviewTarget.innerText = event.target.value;
    }
  }

  change_name(event) {
    this.namePreviewTarget.innerText = event.target.value;
  }

  change_price(event) {
    this.pricePreviewTarget.innerText = event.target.value;
  }

  change_single(event) {
    const singleText = document.getElementById("singleText");
    if (event.target.checked) {
      this.singlePreviewTarget.innerText = singleText.value;
    } else {
      this.singlePreviewTarget.innerText = "";
    }
    this.update_visuality(this.singlePreviewTarget, event.target.checked)
  }

  change_validity(event) {
    const validityText = document.getElementById("validityText");
    if (event.target.checked) {
      this.validityPreviewTarget.innerText = validityText.value;
    } else {
      this.validityPreviewTarget.innerText = "";
    }
    this.update_visuality(this.validityPreviewTarget, event.target.checked)
  }

  change_cash(event) {
    const cashText = document.getElementById("cashText");
    if (event.target.checked) {
      this.cashPreviewTarget.innerText = cashText.value;
    } else {
      this.cashPreviewTarget.innerText = "";
    }
    this.update_visuality(this.cashPreviewTarget, event.target.checked)
  }

  change_stock(event) {
    const stockText = document.getElementById("stockText");
    if (event.target.checked == true) {
      this.stockPreviewTarget.innerText = stockText.value;
    } else {
      this.stockPreviewTarget.innerText = "";
    }
    this.update_visuality(this.stockPreviewTarget, event.target.checked)
  }

  change_promocode(event){
    this.promocodePreviewTarget.innerText = event.target.value;
  }

  change_website(event){
    this.websiteUrlPreviewTarget.innerText = event.target.value;
  }
  
  
  change_expiration_date(event) {
    let currentDate = new Date();
    let nextDateMs =
      currentDate.getTime() + event.target.value * 24 * 60 * 60 * 1000;
    let nextDate = new Date(nextDateMs);
    const res =
      event.target.value != ""
        ? nextDate.toLocaleString("default", { month: "long" }) +
          " " +
          nextDate.getDate() +
          ", " +
          nextDate.getFullYear()
        : currentDate.toLocaleString("default", { month: "long" }) +
          " " +
          currentDate.getDate() +
          ", " +
          currentDate.getFullYear();
    this.expirationDatePreviewTarget.innerText = res;
  }

  change_description(event) {
    if(!document.getElementById("campaign_message")){
      this.descriptionPreviewTarget.innerHTML = event.target.value;
    }
  }

  change_amount(event) {
    if(event.target.type === "checkbox"){
      if(event.target.checked){
        this.amountPreviewTarget.innerText = "Unlimited"
      } else {
        this.amountPreviewTarget.innerText = ""
      }
      document.getElementById("coupon_amount").value = "";
      
    } else {
      this.amountPreviewTarget.innerText = event.target.value;
    }
  }

  update_visuality(element, checked){
    checked ? element.classList.remove("hidden") : element.classList.add("hidden")
  }

  openMarkAsUsed(){
    document.getElementsByTagName('body')[0].style = "overflow: hidden";
    this.containerTarget.classList.remove("hidden")
  }

  closeMarkAsUsed(){
    document.getElementsByTagName('body')[0].style = "overflow: initial";
    this.containerTarget.classList.add("hidden")
  }

  markAsUsedRequest(){
    this.closeMarkAsUsed();

    fetch(`/client_coupons/${this.couponIdTarget.value}/mark_used`, {
      method: "POST"
    });

    this.reloadPage();
  }

  reloadPage(){
    if (window?.Android && typeof window.Android.reloadWebView == "function") {
      Android.reloadWebView();
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "reloadWebView"
      });
    }
  }


  async promocodeValidation(e){
    const promocode = e.target.value;
      if (promocode.length < 6 || promocode.length > 10){
        this.messageComponentTarget.classList.remove("hidden");
        this.errorIconTarget.classList.remove("hidden");
        this.successIconTarget.classList.add("hidden");
        this.messageTarget.innerText = "The promocode should be between 6 to 10 characters";
        this.submitButtonTarget.setAttribute("disabled", true);
      } else {
        const response = await fetch('/company/coupons/validate_promocode?promocode=' + promocode, {
          method: "GET"
        });

        const responseData = await response.json();
        const message = responseData.message;

        this.messageComponentTarget.classList.remove("hidden");
        if (response.status === 444){
          this.errorIconTarget.classList.remove("hidden");
          this.successIconTarget.classList.add("hidden");
        } else {
          this.successIconTarget.classList.remove("hidden");
          this.errorIconTarget.classList.add("hidden");
          this.submitButtonTarget.setAttribute("disabled", false);
        }
        this.promocodeTarget.value = promocode
        this.messageTarget.innerText = message;
    }
  }

  async promocodeRequest(){
    const response = await fetch('/company/coupons/generate_token', {
      method: "GET"
    });

    const responseData = await response.json();
    const promocode = responseData.promocode;

    this.messageComponentTarget.classList.add("hidden");
    this.promocodeTarget.value = promocode;
  }

  coupon_detail({ params }) {
    const coupon = JSON.parse(this.couponDataTarget.value);
    const couponBalance = document
      .querySelector("#coupon-balance")
      ?.getAttribute("data-balance");
    const loyaltyBalance = document
      .querySelector("#loyalty-balance")
      ?.getAttribute("data-balance");
    const couponType = this.couponDataTarget.getAttribute("data-type");
    const userStatus = this.couponDataTarget.getAttribute("data-authorized");
    const authStatus = true;
    if(userStatus == "false"){
       authStatus = false;
    }

    const payload = JSON.stringify({
      ...coupon, 
      balance: this.usersPointsValue,
      openedFrom: params.type,
      is_authorized: authStatus
    });

       
    if (window?.Android) {
      Android.openCouponBottomSheet(payload);
    }

    if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "showCoupon",
        data: {
          ...coupon,
          balance: this.usersPointsValue,
          type: couponType,
          source: couponType,
          openedFrom: params.type,
          is_authorized: authStatus
        },
      });
    }
  }
}
